import * as d3 from 'd3';
import theme from '../../theme';

// Mirrors BollingerBands.js's structure, but dashed + a distinct
// fuchsia/violet trio and a faint fill between the bands (reads as a
// "channel") so it stays visually distinguishable if Bollinger Bands is
// active at the same time.
export const drawKeltnerChannelsIndicator = ({ svg, xScale, yScale, indicators }) => {
    try {
        const { upper_band: upper, lower_band: lower, middle_band: middle } = indicators;

        const bandLine = d3
            .line()
            .x((d) => xScale(d.x))
            .y((d) => (d.y !== null ? yScale(d.y) : null))
            .curve(d3.curveMonotoneX);

        const fillArea = d3
            .area()
            .x((d, i) => xScale(upper[i].x))
            .y0((d, i) => (lower[i].y !== null ? yScale(lower[i].y) : null))
            .y1((d) => (d.y !== null ? yScale(d.y) : null))
            .curve(d3.curveMonotoneX);

        svg.append('path')
            .datum(upper)
            .attr('fill', theme.indicators.keltner.upper)
            .attr('opacity', 0.05)
            .attr('d', fillArea);

        [
            ['upper', upper, theme.indicators.keltner.upper],
            ['middle', middle, theme.indicators.keltner.middle],
            ['lower', lower, theme.indicators.keltner.lower],
        ].forEach(([key, seriesData, color]) => {
            svg.append('path')
                .datum(seriesData)
                .attr('class', `keltner-${key}-line`)
                .attr('fill', 'none')
                .attr('stroke', color)
                .attr('stroke-width', 1.25)
                .attr('stroke-dasharray', key === 'middle' ? null : '4,3')
                .attr('d', bandLine);
        });
    } catch (error) {
        console.warn('Error drawing Keltner Channels:', error);
    }
};

export default drawKeltnerChannelsIndicator;
